module.exports = __webpack_public_path__ + "static/Wonolo-be9319ba42904af2782061a145df498b.jpg";